import * as React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { CourseProviderEdit } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState, SelectInput } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface CPPersonalDataProps {
    courseProvider: CourseProviderEdit;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    savePersonalData: (a: string, b: string, c: string, d: string, e: string, f: string) => void;
}

export interface CPPersonalDataState {
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPersonSalutation: string;
    email: string;
    telephone: string;
    website: string;
    validationError: boolean;
}

export default class CPPersonalData extends React.PureComponent<CPPersonalDataProps, CPPersonalDataState> {
    constructor(props: CPPersonalDataProps) {
        super(props);
        this.state = {
            contactPersonFirstName: '',
            contactPersonLastName: '',
            contactPersonSalutation: '',
            email: '',
            telephone: '',
            validationError: false,
            website: '',
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            contactPersonFirstName: this.props.courseProvider.ContactPersonFirstName,
            contactPersonLastName: this.props.courseProvider.ContactPersonLastName,
            contactPersonSalutation: this.props.courseProvider.ContactPersonSalutation,
            email: this.props.courseProvider.Email,
            telephone: this.props.courseProvider.Telephone,
            website: this.props.courseProvider.Website,
        });
    }

    public render() {
        const { contactPersonFirstName, contactPersonLastName, contactPersonSalutation, email, telephone, website } =
            this.state;
        return (
            <CPItemEditComponent
                name={TR.cPPersonalData_contact_person}
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    if (
                        contactPersonFirstName.length < 3 ||
                        contactPersonLastName.length < 3 ||
                        contactPersonSalutation.length < 3 ||
                        email.length < 3
                    ) {
                        this.setState({ validationError: true });
                    } else {
                        this.setState({ validationError: false }, () => {
                            this.props.savePersonalData(
                                contactPersonFirstName,
                                contactPersonLastName,
                                contactPersonSalutation,
                                email,
                                telephone,
                                website
                            );
                        });
                    }
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={this.state.validationError}
                validationMessage={this.state.validationError ? TR.cPPersonalData_check_data : ''}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.PersonalData) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (
            !this.props.courseProvider.ContactPersonFirstName ||
            !this.props.courseProvider.ContactPersonSalutation ||
            !this.props.courseProvider.ContactPersonLastName ||
            !this.props.courseProvider.Email
        ) {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.cPPersonalData_please_fill} />
                </Col>
            );
        } else {
            return (
                <>
                    <Col md={2}>{TR.cPPersonalData_name}</Col>
                    <Col md={10}>
                        {this.props.courseProvider.ContactPersonSalutation}&nbsp;
                        {this.props.courseProvider.ContactPersonFirstName}&nbsp;
                        {this.props.courseProvider.ContactPersonLastName}
                    </Col>
                    <Col md={2} className="mt-2 mb-2">
                        {TR.cPPersonalData_contact}
                    </Col>
                    <Col md={10} className="mt-2 mb-2">
                        {this.props.courseProvider.Email}&nbsp;,&nbsp;{this.props.courseProvider.Telephone}
                    </Col>
                    <Col md={2} className="mt-2 mb-2">
                        {TR.cPPersonalData_website}
                    </Col>
                    <Col md={10} className="mt-2 mb-2">
                        {this.props.courseProvider.Website}
                    </Col>
                </>
            );
        }
    };

    private renderContentEdit = () => {
        return (
            <>
                <Row>
                    <Col md={3} className="mt-2 mb-2">
                        <Label style={{ color: this.state.contactPersonSalutation.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPPersonalData_salutation}
                        </Label>
                        <SelectInput
                            style={{
                                border: this.state.contactPersonSalutation.length < 3 ? '1px solid red' : 'inherit',
                            }}
                            bsSize={'sm'}
                            id="contactPersonSalutation"
                            name="contactPersonSalutation"
                            selectArr={['', 'Herr', 'Frau']}
                            defaultValue={this.props.courseProvider.ContactPersonSalutation}
                            onChangeOption={this.inputHandler}
                        />
                    </Col>
                    <Col md={4} className="mt-2 mb-2">
                        <Label style={{ color: this.state.contactPersonFirstName.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPPersonalData_first_name}
                        </Label>
                        <Input
                            style={{
                                border: this.state.contactPersonFirstName.length < 3 ? '1px solid red' : 'inherit',
                            }}
                            bsSize={'sm'}
                            autoFocus={true}
                            id="contactPersonFirstName"
                            name="contactPersonFirstName"
                            type="text"
                            placeholder="Vorname"
                            defaultValue={this.props.courseProvider.ContactPersonFirstName}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={5} className="mt-2 mb-2">
                        <Label style={{ color: this.state.contactPersonLastName.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPPersonalData_last_name}
                        </Label>
                        <Input
                            style={{
                                border: this.state.contactPersonLastName.length < 3 ? '1px solid red' : 'inherit',
                            }}
                            bsSize={'sm'}
                            id="contactPersonLastName"
                            name="contactPersonLastName"
                            type="text"
                            placeholder="Nachname"
                            defaultValue={this.props.courseProvider.ContactPersonLastName}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={4} className="mt-1 mb-3">
                        <Label style={{ color: this.state.email.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPPersonalData_email}
                        </Label>
                        <Input
                            style={{ border: this.state.email.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            id="email"
                            name="email"
                            type="text"
                            placeholder="E-Mail"
                            defaultValue={this.props.courseProvider.Email}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={4} className="mt-1 mb-3">
                        <Label>{TR.cPPersonalData_telephone}</Label>
                        <Input
                            bsSize={'sm'}
                            id="telephone"
                            name="telephone"
                            type="text"
                            placeholder="Telefon"
                            defaultValue={this.props.courseProvider.Telephone}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={4} className="mt-1 mb-3">
                        <Label>{TR.cPPersonalData_website2}</Label>
                        <Input
                            bsSize={'sm'}
                            id="website"
                            name="website"
                            type="text"
                            placeholder="Website"
                            defaultValue={this.props.courseProvider.Website}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={12}>
                        <span style={{ fontSize: '14px', color: '#666' }}>{TR.cPPersonalData_main_contact}</span>
                    </Col>
                </Row>
            </>
        );
    };

    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newState = {};
        // @ts-ignore
        newState[e.target.id] = e.target.value.trim();
        this.setState(newState);
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPPersonalData.tsx